// Single source of truth for the liability waiver. Used by the /signup
// flow (step 4) and the WaiverModal backfill shown to existing users
// who never signed. Bump WAIVER_VERSION when the text changes
// materially so we know which version each member agreed to.

export const WAIVER_VERSION = "2026-07";

export const WAIVER_TEXT = `Active Beaches — Liability & Injury Waiver

By signing below, I acknowledge and agree that:

1. Participation in Active Beaches events and activities — including but not limited to volleyball, running, swimming, biking, skating, dancing, fitness challenges, beach games, and other physical or social activities — involves inherent risks of personal injury, illness, property damage, or death.

2. I am voluntarily participating in these activities at my own risk. I am physically able to participate and will not participate beyond my own abilities.

3. I release and hold harmless Active Beaches, its founder, organizers, captains, hosts, volunteers, and fellow participants from any and all liability, claims, or causes of action arising out of or related to any injury, loss, or damage I may suffer in connection with any Active Beaches event, to the fullest extent permitted by law.

4. I agree to follow event instructions and use reasonable judgment about weather, water, traffic, and physical conditions.

5. I am at least 18 years of age (or have a parent/guardian's consent), and I understand this waiver applies to every Active Beaches event I attend while I am a member.

This signature is stored with your account.`;
